<template>
  <NavBar pageName="Dashboard"></NavBar>
  <v-container style="margin-top: 185px;">
    <v-progress-circular v-if="loading" indeterminate size="40" class="d-block mx-auto my-8" />

    <template v-else-if="sections.length > 0">
      <DashboardSectionRenderer
        v-for="section in sections"
        :key="section.id"
        :component-name="section.component_name"
        :config="section.config || {}"
        @show-add-service="showAddNewClientServiceDialog = true"
      />
    </template>

    <v-alert v-else-if="loadError" type="error" variant="tonal">
      {{ t.dashboard.error_loading }}{{ loadError }}
    </v-alert>

    <v-alert v-else type="info" variant="tonal">
      {{ t.dashboard.no_sections }}
    </v-alert>
  </v-container>

  <!-- Add New Client Service Dialog -->
  <AddNewClientService
    :show="showAddNewClientServiceDialog"
    @close="onAddServiceDialogClose"
    @serviceAdded="onServiceAdded"
  />

  <!-- Snackbar for notifications -->
  <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
    {{ snackbar.message }}
  </v-snackbar>
</template>

<script>
import { defineComponent } from 'vue';
import useGetLoggedIn from "@/composables/useGetLoggedIn"
import { log } from "@/composables/useLog";
import NavBar from "@/components/NavBar.vue";
import AddNewClientService from "@/components/AddNewClientService.vue";
import DashboardSectionRenderer from "@/components/dashboard/DashboardSectionRenderer.vue";
import store from "@/store";
import { t as tRef } from "@/composables/useLanguages";
import { getDashboardConfig } from "@/composables/useDashboardTemplatesAPI";

export default defineComponent({
  name: 'DashBoard',
  components: {
    NavBar,
    AddNewClientService,
    DashboardSectionRenderer
  },
  data() {
    return {
      token: '',
      user: null,
      loading: true,
      loadError: null,
      sections: [],
      templateName: '',
      showAddNewClientServiceDialog: false,
      snackbar: {
        show: false,
        message: '',
        color: 'success'
      }
    }
  },
  computed: {
    t() {
      return tRef.value;
    }
  },
  methods: {
    async loadDashboardConfig() {
      this.loading = true
      this.loadError = null
      try {
        log(`Dashboard: calling getDashboardConfig with token: ${this.token ? 'present' : 'missing'}`)
        const result = await getDashboardConfig(this.token)
        log(`Dashboard: result received`, result)
        if (!result.error) {
          this.sections = result.sections || []
          this.templateName = result.template?.name || ''
          log(`Dashboard: loaded template "${this.templateName}" with ${this.sections.length} sections`)
        } else {
          this.loadError = result.message || this.t.dashboard.unknown_error
          log(`Dashboard: error loading config - ${result.message}`)
        }
      } catch (err) {
        this.loadError = err.message || this.t.dashboard.error_loading_config
        log(`Dashboard: exception loading config`, err)
      } finally {
        this.loading = false
      }
    },
    onAddServiceDialogClose() {
      this.showAddNewClientServiceDialog = false;
    },
    onServiceAdded() {
      this.showAddNewClientServiceDialog = false;
      this.showSnackbar(this.t.client_services.service_added, 'success');
    },
    showSnackbar(message, color = 'success') {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    }
  },
  async created() {
    const { getLoggedIn } = useGetLoggedIn()
    await getLoggedIn()
    log("Dashboard: user loaded")
    this.user = store.getters.getUser
    this.token = store.getters.getToken
    await this.loadDashboardConfig()
  }
});
</script>
